import { Component, Input } from '@angular/core';
import {ExpandCollapseStateService} from "../services/expand-collapse-state.service";

@Component({
  selector: 'app-expand-collapse-button',
  standalone: true,
  imports: [],
  templateUrl: './expand-collapse-button.component.html',
  styleUrl: './expand-collapse-button.component.scss'
})
export class ExpandCollapseButtonComponent { 
  @Input() targetSectionId: string = '';
  
  constructor(protected expandCollapseStateService: ExpandCollapseStateService) {
  }
  
  toggleExpandCollapse() {
    this.expandCollapseStateService.toggleIsOpen(this.targetSectionId);
  }
}
